import { createRouter, createWebHistory } from 'vue-router'
import vueAPI from '@/modules/vueAPI.js'
// import mainPage from '@/views/mainPage.vue'
import mainPage from '@/components/adminPanel/main.vue'
// import dashboardMenu from '@/components/adminPanel/mainBlocks/dashboardMenu.vue'
import loginPage from '@/components/login/loginPage.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: mainPage,
        meta: {
            requiresAuth: true
        },
        // children: [
        //     {
        //         path: '',
        //         name: 'dashboard',
        //         component: dashboardMenu
        //     }
        // ]
    },
    {
        path: '/login',
        name: 'login',
        component: loginPage
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            }
        } else {
            return { top: 0 }
        }
    }
})

router.beforeEach(async (to) => {
    const thisVue = await vueAPI.asyncOnMounted()
    console.log('mounted')
    if (to.meta.requiresAuth || to.meta.requiresGuest) {
        if (thisVue.$store.getters.getCheckingForLogin) {
            await new Promise((resolve, reject) => {
                let unwatchThis = thisVue.$watch('$store.getters.getCheckingForLogin', () => {
                    unwatchThis()
                    resolve()
                })
            })
        }

        if (to.meta.requiresAuth) {
            if (!thisVue.$store.getters.getLoginState) return{ path: '/login' }
        } else if (to.meta.requiresGuest) {
            if (thisVue.$store.getters.getLoginState) return { path: '/' }
        }
    }

    return true
})

export default router
